import * as React from 'react';
import {FunctionComponent, useEffect} from 'react';
import {CompareReport} from './Compare/CompareReport';

import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {ReportShowContainerPresenter} from './ReportShowContainerPresenter';
import {Link, useParams} from 'react-router-dom';
import {Loader} from '../../Components/Utils/Loader';
import {ErrorPlaceholder} from '../../Components/Utils/ErrorPlaceholder';
import {ReportType} from '../../../Models/ReportType';
import {TrendReport} from './Trend/TrendReport';

interface OwnProps {}

const ReportShowContainerComponent: FunctionComponent<OwnProps & PresenterProps<ReportShowContainerPresenter>> =
    observer(({presenter}) => {
        const {id} = useParams<{id: string}>();

        useEffect(() => {
            presenter.load(id!);
        }, [id]);

        if (presenter.result.status === 'loading') {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12 d-flex flex-row justify-content-start">
                            <Link to="/reports" className="btn btn-back-arrow">
                                <i className="bi bi-arrow-left"></i>
                            </Link>
                            <h1>Report</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Loader className="mt-5" text={presenter.result.message || null} />
                        </div>
                    </div>
                </div>
            );
        }

        if (presenter.result.status === 'error') {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-12 d-flex flex-row justify-content-start">
                            <Link to="/reports" className="btn btn-back-arrow">
                                <i className="bi bi-arrow-left"></i>
                            </Link>
                            <h1>Report</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <ErrorPlaceholder large className="mt-5" />
                        </div>
                    </div>
                </div>
            );
        }

        switch (presenter.type!) {
            case ReportType.COMPARE:
                return (
                    <CompareReport
                        snippetCollectionIds={presenter.result.data.snippet_collection_ids}
                        userIds={presenter.result.data.user_ids}
                        crewIds={presenter.result.data.crew_ids}
                        dateRange={{
                            from: presenter.result.data.from,
                            till: presenter.result.data.till,
                        }}
                        report={presenter.result.data}
                    />
                );
            case ReportType.TREND:
                return (
                    <TrendReport
                        report={presenter.result.data}
                        dateRange={{
                            from: presenter.result.data.from,
                            till: presenter.result.data.till,
                        }}
                    />
                );
        }
    });

export const ReportShowContainer = withPresenter<ReportShowContainerPresenter, OwnProps>(
    (props, component) => new ReportShowContainerPresenter(component.network.report),
    ReportShowContainerComponent,
);
